import { FC } from 'react';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import { toMemMarkdown } from '../memTextFormat';

export interface MemMarkdownProps {
  text: string | null | undefined;
}

/** Renders Obsidian-flavoured learner markdown (mems and nuggets). */
export const MemMarkdown: FC<MemMarkdownProps> = ({ text }) => (
  <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
    {toMemMarkdown(text)}
  </Markdown>
);
